module.exports = __webpack_public_path__ + "6faef29b5227a1020aac6cb6ca8a0915.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/psyker-blast-video-poster.jpg
// module id = 517
// module chunks = 0